module.exports = __webpack_public_path__ + "static/img/perth.7efba64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/perth.jpg
// module id = EgJc
// module chunks = 1